import { render, staticRenderFns } from "./CardNotes.vue?vue&type=template&id=649e62ac&scoped=true&"
import script from "./CardNotes.vue?vue&type=script&lang=js&"
export * from "./CardNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e62ac",
  null
  
)

export default component.exports